var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegacycertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 20C13.0001 13.9249 17.925 9 24.0001 9C30.0753 9 35.0001 13.9249 35.0001 20C35.0001 26.0751 30.0753 31 24.0001 31C17.925 31 13.0001 26.0751 13.0001 20Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0001 34.391C36.328 31.7942 39.999 26.3258 39.999 20C39.999 11.1634 32.8356 4 23.999 4C15.1625 4 7.99902 11.1634 7.99902 20C7.99902 26.3267 11.6711 31.7957 17.0001 34.3921V43.0001C17.0001 43.3689 17.2031 43.7078 17.5283 43.8818C17.8534 44.0558 18.248 44.0367 18.5548 43.8322L24.0001 40.202L29.4454 43.8322C29.7523 44.0367 30.1468 44.0558 30.472 43.8818C30.7971 43.7078 31.0001 43.3689 31.0001 43.0001V34.391ZM23.999 34C31.731 34 37.999 27.732 37.999 20C37.999 12.268 31.731 6 23.999 6C16.267 6 9.99902 12.268 9.99902 20C9.99902 27.732 16.267 34 23.999 34Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegacycertificate);
export default __webpack_public_path__ + "static/media/legacycertificate.a035d9795eccce208ef000610714efd4.svg";
export { ForwardRef as ReactComponent };